export default __webpack_public_path__ + "static/media/estj@3x.4c73be88.png";